export const historiesReducer = (state = [], action) => {
    switch (action.type) {
        case "HSTRI":
            return [...action.payload];
        default:
            return state;
    }
};
